import { css } from '@emotion/css';
import { m } from '@snapchat/snap-design-system-marketing';

export const messageActionsCss = css`
  align-items: center;
  display: flex;
  gap: ${m('--spacing-xs')};
  justify-content: flex-start;
  padding-top: ${m('--spacing-xs')};
`;

export const actionButtonCss = css`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  margin: calc(-1 * ${m('--spacing-xs')});
  padding: ${m('--spacing-xs')};
`;

export const actionButtonIconNudgeCss = css`
  position: relative;
  top: 1px;
`;
